const HASH_HEX_CHAR_COUNT = 3;
const HASH_BUCKET_COUNT = 16 ** HASH_HEX_CHAR_COUNT;

export function isUuidSampled(uuid: string, sampleRate: number): boolean {
  const bucket = parseInt(uuid.replace(/-/g, '').substring(0, HASH_HEX_CHAR_COUNT), 16);
  return bucket < Math.floor(HASH_BUCKET_COUNT * sampleRate);
}
